<div *ngIf="hiddenSelect">
    <p-dropdown [options]="genericos" [(ngModel)]="item" (onChange)="sendCategoria($event)" [filter]="true" class="heightDropdown"></p-dropdown>

</div>